
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 41.928 40.757"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"b","x1":".5","x2":".5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#74ce00"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0c9a52"}})]),_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"100%","height":"100%","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"3"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_c('feFlood',{attrs:{"flood-opacity":".161"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 7855","d":"M-341.447 198.37l3.892 7.222 8.071 1.47-5.665 5.938 1.1 8.131-7.394-3.555-7.394 3.555 1.1-8.131-5.666-5.934 8.071-1.47z","transform":"translate(362.41 -192.37)","fill":"url(#b)"}})])])
          )
        }
      }
    